import site from "../site";
import Helpers from "./helpers";
import Logger from "./logger";
import Tooltip from "./tooltip";

declare var slideToggle: any;
declare var Mustache: any;
declare var $: any;

export default class DeliveryEstimate {

	private abortController: AbortController = null;
	private deliveryLoadingDisplayTimer: any = null;
	private waitTimeBeforeShowingLoader = 200;
	private loadingCSSClass = "is-loading";
	private isPPC = false;

	private estimateTemplate: string;
	private estimateBottomTemplate: string;
	private stickyFloaterTemplate: string;

	private estimateTarget: HTMLDivElement;
	private estimateBottomTarget: HTMLDivElement;

	constructor() {

		const deliveryEstimateTemplate = document.getElementById('estimateTemplate');

		if (!document.getElementById('estimateTemplate')) {
			return;
		}

		this.estimateTemplate = deliveryEstimateTemplate.innerHTML;
		this.estimateBottomTemplate = document.getElementById('estimateBottomTemplate').innerHTML;
		this.stickyFloaterTemplate = document.getElementById('stickyFloaterEstimateTemplate').innerHTML;

		this.estimateTarget = document.getElementById('estimate') as HTMLDivElement;
		this.estimateBottomTarget = document.getElementById('estimateBottom') as HTMLDivElement;

		this.isPPC = document.querySelector('[data-ppc-page]') !== null;
	}

	public getEstimate(sku: string) {

		if (this.abortController) {
			this.abortController.abort();
			this.abortController = null;
			this.renderEstimateLoading();
		}

		this.abortController = new AbortController();
		const signal = this.abortController.signal;

		this.clearDeliveryLoadingDisplayTimer();
		this.deliveryLoadingDisplayTimer = setTimeout(() => {
			this.renderEstimateLoading();
		}, this.waitTimeBeforeShowingLoader);

		return fetch(`/api/deliveryestimation/deliveryestimation?productId=${sku}&ppc=${this.isPPC}`, {
			signal: signal
		})
			.then((response)=> {
				if (response.ok) {
					return response.json();
				}
				else {
					throw new Error("Error retrieving delivery estimate");
				}
			}).then((response) => {

				this.clearDeliveryLoadingDisplayTimer();

				const renderedEstimate = Mustache.render(this.estimateTemplate, response.estimate);
				if (this.estimateTarget) {
					this.estimateTarget.innerHTML = renderedEstimate;
					this.estimateTarget.classList.remove(this.loadingCSSClass);
				}

				const renderedEstimateBottom = Mustache.render(this.estimateBottomTemplate, response.estimate);
				if (this.estimateBottomTarget) {
					this.estimateBottomTarget.innerHTML = renderedEstimateBottom;
					this.estimateBottomTarget.classList.remove(this.loadingCSSClass);
				}

				const renderedStickyFloaterEstimate = Mustache.render(this.stickyFloaterTemplate, {
					DeliveryEstimate: response.estimate
				});

				const stickyFloaterTarget = this.getStickyFloaterTarget();
				if (stickyFloaterTarget) {
					stickyFloaterTarget.innerHTML = renderedStickyFloaterEstimate;
					stickyFloaterTarget.classList.remove(this.loadingCSSClass);
				}
					

				this.abortController = null;
				this.reinitRequiredScripts();
				this.signalDeliveryEsimateHasLoaded();
				return response;

			}).catch((error) => {
				this.clearDeliveryLoadingDisplayTimer();
				if (error.name !== 'AbortError') {
					Helpers.empty(this.estimateTarget);
					Helpers.empty(this.getStickyFloaterTarget());
					this.estimateTarget.classList.remove(this.loadingCSSClass);
					this.estimateBottomTarget.classList.remove(this.loadingCSSClass);
					Logger.trackException(error);
				}
			});
	}

	private renderEstimateLoading() {
		if (this.isPPC) {
			return;
		}
		const renderedEstimateLoading = Mustache.render($('#productDeliveryEstimateLoadingTemplate').html(), {});
		const stickyFloaterTarget = this.getStickyFloaterTarget();

		if (this.estimateTarget) {
			this.estimateTarget.innerHTML = renderedEstimateLoading;
			this.estimateTarget.classList.add(this.loadingCSSClass);
		}
		
		if (stickyFloaterTarget) {
			stickyFloaterTarget.innerHTML = renderedEstimateLoading;
			stickyFloaterTarget.classList.add(this.loadingCSSClass);
		}
	}

	private clearDeliveryLoadingDisplayTimer() {
		if (this.deliveryLoadingDisplayTimer) {
			clearTimeout(this.deliveryLoadingDisplayTimer);
		}
	}

	private reinitRequiredScripts() {
		(<any>window).initProductCountdown();
		if (Tooltip) {
			Tooltip.init(false);
		}
		if (site) {
			site.smoothScroll();
		}
		if (slideToggle) {
			slideToggle.init();
		}
	}

	private signalDeliveryEsimateHasLoaded() {
		const deliveryEstimateLoadedEvent = Helpers.createCustomEventForDispatch('deliveryEstimateLoaded');
		document.dispatchEvent(deliveryEstimateLoadedEvent);
	}

	private getStickyFloaterTarget() {
		return document.getElementById('stickyFloaterEstimate');
	}

}
